var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-1"},[_c('v-switch',{staticClass:"pt-2 mt-0",attrs:{"input-value":_vm.promoFilter,"inset":"","label":"Promozioni","dense":"","hide-details":""},on:{"change":_vm.handlePromoFilter,"click":function($event){return _vm.trackFilter('In evidenza', 'Promozioni', !_vm.promoFilter)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }